module.exports = __webpack_public_path__ + "img/ico_scoup.64a3078.svg";